/* eslint-disable no-undef */
/* eslint-disable max-len */
import React from 'react';
import { Redirect, Switch, Route, BrowserRouter } from 'react-router-dom';
import HeaderVertical from 'ui/components/layout/header.vertical';

// Read subrouter in each subfolder
let routes = [];
const rf = require.context('./', true, /^.*_subrouter.js$/);
rf.keys().forEach((fileName) => {
  routes = routes.concat(rf(fileName).default);
});

const Router = () => {
  return (
    <BrowserRouter>
      <div className="row bg-dark h-100">
        <div className="col-4 col-md-3 p-0 h-100 d-none d-md-block">
          <HeaderVertical />
        </div>

        <div className="col-12 col-md-9 ">
          <Switch>
            {routes.map((route, i) => (
              <Route
                key={i}
                exact
                path={route.path}
                component={route.component}
              />
            ))}
            <Redirect exact from="/*" to="/onboarding-client" />
          </Switch>
        </div>
      </div>
    </BrowserRouter>
  );
};

export default Router;
